import { ThemingConfig } from '@chakra-ui/react';

import accordionRecipe from './accordion';
import alertRecipe from './alert';
import assetImageRecipe from './assetImage';
import blockElementRecipe from './blockElement';
import checkboxRecipe from './checkbox';
import dataListRecipe from './dataList';
import dialogRecipe from './dialog';
import drawerRecipe from './drawer';
import fieldRecipe from './field';
import listRecipe from './list';
import menuRecipe from './menu';
import modalRecipe from './modal';
import nativeSelectRecipe from './nativeSelect';
import progressCircleRecipe from './progressCircle';
import radioCardRecipe from './radioButtonGroup';
import radioGroupRecipe from './radioGroup';
import segmentGroupRecipe from './segmentGroup';
import selectRecipe from './select';
import sidebarRecipe from './sidebar';
import summaryHeaderContentRecipe from './summaryHeaderContent';
import switchRecipe from './switch';
import tableRecipe from './table';
import tabsRecipe from './tabs';
import tagRecipe from './tag';
import toastRecipe from './toast';
import tooltipRecipe from './tooltip';

const slottedRecipes: ThemingConfig['slotRecipes'] = {
  accordion: accordionRecipe,
  alert: alertRecipe,
  assetImage: assetImageRecipe,
  blockElement: blockElementRecipe,
  checkbox: checkboxRecipe,
  dataList: dataListRecipe,
  drawer: drawerRecipe,
  dialog: dialogRecipe,
  field: fieldRecipe,
  nativeSelect: nativeSelectRecipe,
  list: listRecipe,
  menu: menuRecipe,
  modal: modalRecipe,
  progressCircle: progressCircleRecipe,
  radioCard: radioCardRecipe,
  radioGroup: radioGroupRecipe,
  segmentGroup: segmentGroupRecipe,
  select: selectRecipe,
  sidebar: sidebarRecipe,
  summaryHeaderContent: summaryHeaderContentRecipe,
  switch: switchRecipe,
  table: tableRecipe,
  tabs: tabsRecipe,
  tag: tagRecipe,
  toast: toastRecipe,
  tooltip: tooltipRecipe,
};

export default slottedRecipes;
